import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "currencyFilled"
const CurrencyFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M21.826 7.796C22.786 10.041 22.949 12.548 22.286 14.899 21.625 17.25 20.177 19.303 18.187 20.716 16.192 22.129 13.777 22.818 11.34 22.667 9.487 22.552 7.707 21.957 6.168 20.954V22.444H4.293V17.794H8.943V19.669H7.661C8.817 20.323 10.113 20.713 11.456 20.796 13.466 20.92 15.457 20.352 17.1 19.186 18.742 18.022 19.936 16.329 20.482 14.39S20.894 10.385 20.102 8.534z" />
          <path
            fillRule="evenodd"
            d="M12.83 7.323C13.402 7.409 13.958 7.607 14.51 7.96L14.767 8.138 14.916 8.246 14.811 8.396 13.918 9.673 13.795 9.848 13.637 9.702C13.314 9.402 12.76 9.165 12.222 9.165 11.919 9.165 11.61 9.23 11.385 9.365 11.167 9.495 11.032 9.682 11.032 9.946 11.032 10.196 11.202 10.39 11.577 10.592 11.76 10.69 11.977 10.782 12.218 10.879 12.456 10.976 12.718 11.077 12.978 11.189 13.5 11.413 14.042 11.697 14.455 12.128 14.874 12.566 15.15 13.148 15.15 13.95 15.15 15.355 14.116 16.385 12.83 16.7V18.153H10.924V16.69C10.123 16.51 9.377 16.117 8.725 15.549L8.588 15.426 8.448 15.296 9.702 13.987 9.842 13.842 9.975 13.989C10.457 14.52 11.188 14.91 11.941 14.91 12.628 14.91 13.054 14.498 13.055 13.976 13.055 13.522 12.74 13.246 12.184 12.983 11.908 12.853 11.598 12.738 11.268 12.606 10.943 12.476 10.603 12.332 10.291 12.149 9.555 11.72 8.936 11.055 8.936 9.959 8.936 8.67 9.834 7.79 10.926 7.438V5.921H12.83z"
            clipRule="evenodd"
          />
          <path d="M12.66 1.333C14.49 1.446 16.249 2.027 17.775 3.007V1.5H19.649V6.15H15V4.275H16.239C15.108 3.655 13.848 3.285 12.544 3.205 10.534 3.08 8.542 3.647 6.9 4.813S4.064 7.672 3.518 9.61 3.106 13.615 3.898 15.467L2.174 16.204C1.213 13.96 1.05 11.452 1.713 9.101S3.823 4.698 5.815 3.284C7.806 1.871 10.222 1.182 12.66 1.334" />
        </svg>
      }
    </span>
  )
}
export default CurrencyFilledIcon
